import { useCurrentUser } from '../../hooks/useCurrentUser';
import { POSITIONS_EXPERIENCE_SUBSTEP, usePositionsSubStep } from './positionsSubStepStore';

export enum ApplicationStatus {
  AccountInfo = 'account_info',
  Markets = 'markets',
  Positions = 'positions',
  WorkExperience = 'work_experience',
  LicensesAndCerts = 'licenses_and_certs',
  QAndA = 'q_and_a',
  ResumeReview = 'resume_review',
  PhoneScreenPending = 'phone_screen_pending',
  PhoneScreenScheduled = 'phone_screen_scheduled',
  Archived = 'archived',
  Approved = 'approved',
}

export type ApplicationPhase = {
  phaseLabel: string;
  percent: number;
};

export const APPLICATION_PHASE_MAP: Record<ApplicationStatus, ApplicationPhase> = {
  [ApplicationStatus.AccountInfo]: { phaseLabel: 'Account Info', percent: 5 },
  [ApplicationStatus.Markets]: { phaseLabel: 'Markets', percent: 10 },
  [ApplicationStatus.Positions]: { phaseLabel: 'Positions', percent: 20 },
  [ApplicationStatus.WorkExperience]: { phaseLabel: 'Work Experience', percent: 50 },
  [ApplicationStatus.LicensesAndCerts]: { phaseLabel: 'License/Cert', percent: 65 },
  [ApplicationStatus.QAndA]: { phaseLabel: 'Q&A', percent: 75 },
  [ApplicationStatus.ResumeReview]: { phaseLabel: 'Resume Review', percent: 80 },
  [ApplicationStatus.PhoneScreenPending]: { phaseLabel: 'Phone Screen Pending', percent: 90 },
  [ApplicationStatus.PhoneScreenScheduled]: { phaseLabel: 'Phone Screen Scheduled', percent: 95 },
  [ApplicationStatus.Archived]: { phaseLabel: 'Work Experience', percent: 50 },
  [ApplicationStatus.Approved]: { phaseLabel: 'Approved', percent: 100 },
};

export const YEARS_OF_EXPERIENCE_PHASE: ApplicationPhase = {
  phaseLabel: 'Years of Experience',
  percent: 30,
};

export const getApplicationPhase = (
  status?: string | null,
  positionsSubStep?: number,
): ApplicationPhase | null => {
  if (!status) {
    return null;
  }

  if (status === ApplicationStatus.Positions && positionsSubStep === POSITIONS_EXPERIENCE_SUBSTEP) {
    return YEARS_OF_EXPERIENCE_PHASE;
  }

  return APPLICATION_PHASE_MAP[status as ApplicationStatus] ?? null;
};

export const useApplicationProgress = (): ApplicationPhase | null => {
  const { currentUser } = useCurrentUser();
  const positionsSubStep = usePositionsSubStep();

  return getApplicationPhase(currentUser?.professional?.application_status, positionsSubStep);
};
